var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"footer px-3 py-1"},[_vm._v(" © "+_vm._s(_vm.currentYear)+" DunningOnline "),_c('div',{staticClass:"float-right success d-none d-lg-block"},[_c('icon',{attrs:{"prefix":"fas","name":"check-circle"}}),_vm._v(" "+_vm._s(_vm._f("datetime")(new Date()))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }